export const iconFontAwesomeCharityRibbon = (
	<i className="fa-solid fa-ribbon"></i>
);
